import { LAB_REPORT, PAYMENT_MODULE } from "@/api_framework/api_config";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import { useAPIUtils } from "../../useAPIUtils";
import toast from "react-hot-toast";

AxiosCurlirize(axios, () => {});
type ICartAPIResponse = { status: boolean; message: string };

export interface ILabSampleRequest {
  requisition_id: string;
  lab_partner_id: string;
  test_barcode: string;
}
export const useSampleRequestAPI = () => {
  const configuration = useConfiguration();

  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  // isCustomerWalletDetailsInProgress
  const execute = useCallback(
    async (reqId?: string, action?: any) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: ICartAPIResponse = await axios
          .get(`${LAB_REPORT?.TRF_GENERATE?.baseURL}?requisition_id=${reqId}&action=${action}`, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<any>) => {
            if (res.data.status === true) {
              toast.success(res.data.message);
              return { status: true, message: "Cart Level Coupons Fetched" };
            } else {
              return { status: false, message: "No Cart Level Coupons" };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            captureError(e);
            return { status: false, message: "cart_not_filtered" };
          });
        return response;
      } catch (e: any) {
        captureError(e);
      }
    },
    [dispatch],
  );
  return { execute };
};
